module.exports = __webpack_public_path__ + "static/media/logo9.06012991.png";